var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"yah-logo",style:({'background-image': _vm.yahLogo}),attrs:{"data-translation-element":"yah"},on:{"click":function($event){return _vm.onClicked()}}},[_vm._v("\n\tYAH\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }